// extracted by mini-css-extract-plugin
export default {"root":"adc__root--KqQR9","bg":"adc__bg--_UW1I","fg":"adc__fg--H9Wup","invert":"adc__invert--g68xt"};